import firebase from 'firebase/app'
import { isNil } from 'lodash'

import store from '@/store'

firebase.auth().onAuthStateChanged(firebaseUser => {
  const actionToDispatch = isNil(firebaseUser) ? 'signout' : 'signin'
  store.dispatch(`authentication/${actionToDispatch}`, firebaseUser)
})
